import React, { useState, useEffect, useCallback } from 'react';
import { saasData } from '../../lib/supabase';
import './TeacherInfoPage.css';

const TeacherInfoPage = ({ onBack, onTabChange }) => {
  const [teacherData, setTeacherData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch teacher data from Supabase
  const fetchTeacherData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // TODO: Implement teacher data fetching
      // For now, use placeholder data
      setTeacherData({
        totalTeachers: 0,
        teachers: []
      });
      
      setLoading(false);
    } catch (err) {
      console.error('Error fetching teacher data:', err);
      setError(err.message || 'Failed to fetch teacher data');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeacherData();
  }, [fetchTeacherData]);

  if (loading) {
    return (
      <div className="teacher-info-page">
        <div className="teacher-info-header">
          <button onClick={onBack} className="back-button">← Back</button>
          <h1>Teacher Information</h1>
        </div>
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="teacher-info-page">
        <div className="teacher-info-header">
          <button onClick={onBack} className="back-button">← Back</button>
          <h1>Teacher Information</h1>
        </div>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="teacher-info-page">
      <div className="teacher-info-header">
        <button onClick={onBack} className="back-button">← Back</button>
        <h1>Teacher Information</h1>
      </div>
      <div className="teacher-info-content">
        <p>Teacher information module is under development.</p>
        {teacherData && (
          <div>
            <p>Total Teachers: {teacherData.totalTeachers || 0}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherInfoPage;

